import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAuth } from "../../contexts/AuthContext";

export const OpsTest: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  
  // TODO: Remove debug logging when ready for production

  return (
    <Box p={4}>
      <Typography variant="h3" gutterBottom>
        Harness Ops Test Page
      </Typography>
      <Typography variant="body1">
        This is a simple test page to verify routing is working.
      </Typography>
      <Typography variant="body2" sx={{ mt: 2 }}>
        User: {user?.email || 'Not authenticated'}
      </Typography>
      <Typography variant="body2">
        Role: {user?.role || 'No role'}
      </Typography>
      <Typography variant="body2">
        Authenticated: {isAuthenticated ? 'Yes' : 'No'}
      </Typography>
    </Box>
  );
};